import React, {useState} from 'react'
import styled from 'styled-components';
import { TextInput } from '../../styles/reusables';
import { MainButton, BackButton } from '../../styles/buttons';
import TemplateItem from '../template-item';
import { submitForm } from '../../utils/formFunctions';
import template1 from '../../images/template.png';
import template2 from '../../images/template2.png';

const Container = styled.form`
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    width: 100%;

    button {
        max-width: 250px;
        margin: 0 auto;
    }
`;

const Wrapper = styled.div`
width: 100%;
padding: 0 20px;
text-align: center;

>button {
	margin-top: 50px;
}

`;

const FileInput = styled.input`
`;

const FileInputWrapper = styled.label`
		width: 100%;
    padding: 10px 20px;
    font-family: "Lato";
    box-shadow: 0px 3px 6px #00000015;
    border: 1px solid #EFEFEF;
    border-radius: 2px;
    font-size: 17px;
		margin-bottom: 15px;
		cursor: pointer;
		background: #fff;
		color: #858585;
`;

const Templates = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
grid-column-gap: 20px;
justify-items: center;
`;


const NewUserTemplate = ({ setStep }) => {

	const [state, setState] = useState({ 
		fullName: '', 
		businessName: '', 
		logo: '',
		email: '',
		phone: '',
		template: 'backpack'
	})

	const handleChange = (e) => {

		setState({ ...state, [e.target.name]: e.target.value })
	}

	const handleAttachment = (e) => {
		console.log("handle attachment called");
		console.log(e.target.files[0])
		setState({...state, [e.target.name]: e.target.files[0]})
	}

	const handleSubmit = (e) => {
		e.preventDefault()
		const form = e.target
		const formName = form.getAttribute('name');
		const formAction = form.getAttribute('action');

		submitForm(state, formName, formAction)

	}

    return (
			<Wrapper>
				<Container 
					method="post" 
					name="new-user-template"
					action="/success"
					onSubmit={handleSubmit}
					enctype="multipart/form-data"
				>
            <input type="hidden" name="form-name" value="new-user-template" />
						<input type="hidden" name="bot-field" />

            <TextInput name="fullName" type="text" onChange={handleChange} placeholder="Your name" value={state.fullName}/>
            <TextInput name="businessName" type="text" onChange={handleChange} placeholder="Business name" value={state.businessName}/>
						<FileInputWrapper>
								<FileInput 
									type="file" 
									name="logo"
									onChange={handleAttachment}/>
								upload Logo
						</FileInputWrapper>
            <TextInput name="email" type="email" onChange={handleChange} placeholder="Email address" value={state.email} />
            <TextInput name="phone" onChange={handleChange} placeholder="Phone number" value={state.phone} />
            <TextInput name="template" type="hidden" value={state.template}/>
						<Templates>
							<TemplateItem name="Paria" imgSrc={template1} url="https://hardcore-clarke-2c8435.netlify.app/" />
							<TemplateItem name="Balandra" imgSrc={template2} url="https://heuristic-williams-3ff912.netlify.app/" />
						</Templates>
            <MainButton type="submit">Submit</MainButton>
        </Container>

				<BackButton onClick={() => setStep(2)}>Go Back</BackButton>
			</Wrapper>
    )
}

export default NewUserTemplate